module.exports = __webpack_public_path__ + "img/icon-payment-nfc-orange.e810c2d5.png";